import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Answer from '../../entities/answer';

/*
 * Delete/nullify anywhere this answer is used in other entities
 *
 * @param {Answer} answer
 */
export function deleteAnswer(answer: Answer, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = answer.id;
    }

    /* Remove the actual answer */
    answer.status = 'D';
    answer.addedOn = newHRTimestamp();
    answer.addedBy = getCurrentUserId();
    answer.importSource = targetImportSource;
    answer.importId = mergeId;
    store.dispatch(Actions.AnswerActions.removeAnswerQueue(answer));
    
}